/**
 * Campaign map facade.
 *
 * Older code imports these names as the "global map". They now delegate to the
 * active campaign so the engine can host multiple campaign maps.
 */

import { activeCampaign } from "../campaign/index.js";
import type { FieldId } from "../domain/types.js";

export const GLOBAL_MAP_FIELD_IDS: readonly FieldId[] = activeCampaign.map.fieldIds;
export const STARTING_FIELD_ID: FieldId = activeCampaign.map.startingFieldId;
export const FINAL_FIELD_ID: FieldId = activeCampaign.map.finalFieldId;
export const MAP_ROWS: number = activeCampaign.map.rows;
export const MAP_COLS: number = activeCampaign.map.cols;

export function fieldIdToCoords(fieldId: FieldId): { row: number; col: number } | null {
  return activeCampaign.map.fieldIdToCoords(fieldId);
}

export function isFieldOnLand(fieldId: FieldId): boolean {
  return activeCampaign.map.isFieldPlayable(fieldId);
}

export function getAdjacentMapFieldIds(fieldId: FieldId): FieldId[] {
  return activeCampaign.map.getAdjacentFieldIds(fieldId);
}
